import { http } from '../../lib/http.ts';

// Thin wrappers around every backend endpoint the legacy builder called via
// fetch(). These intentionally do NOT catch/toast — axios rejects on
// non-2xx (unlike fetch(), which only rejects on network failure), so
// callers (in state.ts's api-glue and savedForms.ts/responses.ts/runtime.ts)
// wrap these with try/catch and reproduce the exact per-call-site toast copy
// the legacy fetch() call had at that spot.

export async function ping(): Promise<void> {
  await http.get('/api/ping');
}

export async function listForms(): Promise<any[]> {
  const { data } = await http.get('/api/forms');
  return data;
}

export async function getForm(id: string): Promise<any> {
  const { data } = await http.get('/api/forms/' + id);
  return data;
}

export async function createForm(title: string): Promise<{ id: string }> {
  const { data } = await http.post('/api/forms', { title });
  return data;
}

export async function saveForm(id: string, snapshot: unknown): Promise<void> {
  await http.post('/api/forms/' + id, snapshot);
}

export async function deleteFormApi(id: string): Promise<void> {
  await http.delete('/api/forms/' + id);
}

export async function getResponses(id: string): Promise<any[]> {
  const { data } = await http.get('/api/forms/' + id + '/responses');
  return data;
}

export async function postResponse(id: string, response: unknown): Promise<void> {
  await http.post('/api/forms/' + id + '/responses', response);
}

export async function putResponse(id: string, responseId: string, response: unknown): Promise<void> {
  await http.put('/api/forms/' + id + '/responses/' + responseId, response);
}

export async function publishForm(id: string): Promise<{ status: string; publishedAt: string; publicSlug: string | null }> {
  const { data } = await http.post('/api/forms/' + id + '/publish');
  return data;
}

export async function unpublishForm(id: string): Promise<{ status: string }> {
  const { data } = await http.post('/api/forms/' + id + '/unpublish');
  return data;
}

// Public (unauthenticated) counterparts used by the /f/:id fill page — hit
// /api/public/forms/* instead of the staff-only /api/forms/* routes.
export async function getPublicForm(id: string): Promise<any> {
  const { data } = await http.get('/api/public/forms/' + id);
  return data;
}

export async function postPublicResponse(id: string, response: unknown): Promise<void> {
  await http.post('/api/public/forms/' + id + '/responses', response);
}
